const animation = {
  "ani_01_title": "<span>ผสานนวัตกรรม </span><span><em>วิทยาศาสตร์ </em></span><span>และ </span> <span><em>ศิลปะ</em></span>",
  "ani_01_content": "ออกแบบด้วยวิทยาศาสตร์และศิลปะของงานฝีมือ ให้เข้ากับดวงตาของคุณ รังสรรค์ความงามของคุณด้วย Define®",

  "ani_02_title": "<span><em>เทคโนโลยี </em></span><span>Lacreon® </span><span>ศาสตร์แห่งศิลป์</span>",
  "ani_02_content": "ช่วยกักเก็บความชุ่มชื้นไว้ในเนื้อเลนส์ ลดการระคายเคืองตลอดวัน ",

  "ani_03_title": "<span>ขอบเลนส์บาง ด้วย </span><span><em>invisible </em></span><span>edge&nbsp;design</span>",
  "ani_03_content": "ขอบเลนส์บาง โค้งรับเข้ากับรูปตา",

  "ani_04_title": "<span><em>ดีไซน์ตามหลัก </em></span><span><em> </em></span><span>วิทยาศาสตร์</span>",
  "ani_04_content": "เพลิดเพลินไปกับคอนแทคเลนส์คุณภาพชั้นนำระดับโลก",
}

export default animation
